import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class SchemaSelectFilterPanelComponent implements IController {

  panelRef: any;
  selectedId: any;
  options?: any;
  optionsWrapper?: { list?: any[], propertyRef: string };
  excludeIds: any;
  optionsPrefix: string;
  isHideResetButton: boolean;

  private selectedIdCopy: any;
  public list: any;
  public excludedMap: any;
  public highlightedId: string;

  $onInit() {
    if (this.selectedId !== undefined) {
      this.selectedIdCopy = angular.copy(this.selectedId);
    }

    this.list = this.optionsWrapper ?
      _.map(this.optionsWrapper.list, (o) => {
        return {name: _.get(o, this.optionsWrapper.propertyRef), id: o.id, isRequired: o.isRequired}
      }) :
      _.map(this.options, (o) => {
        return {name: o, id: o}
      });

    this.excludedMap = {};
    _.forEach(this.excludeIds, (id) => {
      this.excludedMap[id] = true;
    })
  }


  onSelectValue(id) {
    this.selectedIdCopy = id;
    this.panelRef.config.onCloseSuccess(this.panelRef, this.selectedIdCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, undefined);
  }

  onMouseEnter(id: string) {
    this.highlightedId = id;
  }

  onMouseLeave() {
    this.highlightedId = undefined;
  }

  onDeleteSchema(id: string) {
    this.panelRef.config.onCloseSuccess(this.panelRef, this.selectedIdCopy, id);
  }

  onDuplicateSchema(id: string) {
    this.panelRef.config.onCloseSuccess(this.panelRef, this.selectedIdCopy, undefined, id);
  }


}

angular
  .module('bringoz.admin.commons')
  .component('schemaSelectFilterPanel', {
    bindings: {
      panelRef: '<',
      selectedId: '<?',
      options: '<?',
      optionsWrapper: '<?',
      optionIds: '<?',
      excludeIds: '<?',
      isHideResetButton: '<?'
    },
    template: require('./schema-select-filter-panel.html').default,
    controller: SchemaSelectFilterPanelComponent
  });
